import { render, staticRenderFns } from "./FolderTreeItem.vue?vue&type=template&id=44bf0a29&"
import script from "./FolderTreeItem.vue?vue&type=script&lang=js&"
export * from "./FolderTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports